import { createContext } from "react";
import { AnalyticsGroupWidgetContextType } from "../../types/widgets";

const AnalyticsGroupWidgetContext = createContext<
  AnalyticsGroupWidgetContextType | undefined
>(undefined);

export { AnalyticsGroupWidgetContext };
